/**
 * Subscription status enumeration
 */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["EXPIRED"] = "EXPIRED";
    SubscriptionStatus["TRIALING"] = "TRIALING";
    SubscriptionStatus["PAUSED"] = "PAUSED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/**
 * Payment provider enumeration
 */
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "STRIPE";
    PaymentProvider["REVENUECAT"] = "REVENUECAT";
    PaymentProvider["APPLE"] = "APPLE";
    PaymentProvider["GOOGLE"] = "GOOGLE";
    PaymentProvider["MANUAL"] = "MANUAL";
})(PaymentProvider || (PaymentProvider = {}));
/**
 * Subscription plan type enumeration
 */
export var SubscriptionPlanType;
(function (SubscriptionPlanType) {
    SubscriptionPlanType["FREE"] = "FREE";
    SubscriptionPlanType["BASIC"] = "BASIC";
    SubscriptionPlanType["PRO"] = "PRO";
    SubscriptionPlanType["PREMIUM"] = "PREMIUM";
    SubscriptionPlanType["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionPlanType || (SubscriptionPlanType = {}));
/** Which of a plan's two prices a subscription or selection bills on. */
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["YEARLY"] = "YEARLY";
})(BillingCycle || (BillingCycle = {}));
